import { _Bottom } from '@angular/cdk/scrolling';
import { FeeQuoteState } from './types';
import {
  ClearFeeQuoteAction,
  GetFeeQuoteFailedAction,
  GetFeeQuoteSucessAction,
  GetFxRateFailedAction,
  GetFxRateSuccessAction,
  SetUserTrnAmountAction,
} from './fee-quote.actions';
import { PaymentDetailsMock, SenderRegistrationMock } from './fee-quote.mock';
import { Action, createReducer, on } from '@ngrx/store';

export const initialState: FeeQuoteState = {
  errors: [],
  transactionAmount: 0,
  transactionCurrency: "",
  feeQuoteData: {
    senderProfile: SenderRegistrationMock,
    additionalInfos: [],
    transactions: [],
    paymentDetails: PaymentDetailsMock,
    cashInWalletFeeEnabled: false,
    cashOutWalletFeeEnabled: false,
  },
  fxRateDetails: {
    fxRates: [],
  },
  fxRateError: [],
};

export function FeeQuoteReducer(state: any = initialState, action: Action) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    GetFeeQuoteSucessAction,
    (state, { feeLookupResponse }) =>
      ({
        ...state,
        feeQuoteData: {
          ...feeLookupResponse,
        },
      } as FeeQuoteState)
  ),
  on(
    GetFxRateFailedAction,
    (state, { error }) =>
      ({
        ...state,
        fxRateError: error,
      } as FeeQuoteState)
  ),
  on(
    GetFxRateSuccessAction,
    (state, { fxRateResponse }) =>
      ({
        ...state,
        fxRateDetails: fxRateResponse,
      } as FeeQuoteState)
  ),
  on(
    SetUserTrnAmountAction,
    (state, { amount }) => ({
        ...state,
        transactionAmount: amount
    } as FeeQuoteState)
),
  on(
    GetFeeQuoteFailedAction,
    (state, { error }) =>
      ({
        ...state,
        errors: error,
      } as FeeQuoteState)
  ),
  on(
    ClearFeeQuoteAction,
    (state) =>
      ({
        ...state,
        feeQuoteData: {
          senderProfile: SenderRegistrationMock,
          additionalInfos: [],
          transactions: [],
          paymentDetails: PaymentDetailsMock,
          cashInWalletFeeEnabled: false,
          cashOutWalletFeeEnabled: false,
        },
      } as FeeQuoteState)
  )
);
